import Vue from 'vue'
import { jsonFormat } from '@/utils/json'
import {
  plainToDateFormat,
  dateToPlainFormat,
  plainToDateTimeFormat,
  dateTimeToPlainFormat,
  dateTimeToDateFormat,
  dateTimeToTimeFormat,
  plainToTimeFormat
} from '@/utils/date'

Vue.filter('jsonFormat', (value: object) => {
  return jsonFormat(value)
})

Vue.filter('plainToDateFormat', (date: string) => {
  return plainToDateFormat(date)
})

Vue.filter('dateToPlainFormat', (date: string) => {
  return dateToPlainFormat(date)
})

Vue.filter('plainToDateTimeFormat', (date: string) => {
  return plainToDateTimeFormat(date)
})

Vue.filter('dateTimeToPlainFormat', (date: string) => {
  return dateTimeToPlainFormat(date)
})

Vue.filter('dateTimeToDateFormat', (date: string) => {
  return dateTimeToDateFormat(date)
})

Vue.filter('dateTimeToTimeFormat', (date: string) => {
  return dateTimeToTimeFormat(date)
})

Vue.filter('plainToTimeFormat', (time: string) => {
  return plainToTimeFormat(time)
})
